import { List } from "@mui/material"
import ElliHost from "../services/elliHost";
import { useDispatch } from "react-redux";
import { addAttachments, clearAttachments, removeAttachment, setLoadingState } from "../state/appSlice";
import { useTypedSelector } from "../hooks/useTypedSelector";
import DeleteIcon from '@mui/icons-material/Delete';
import { GenericCardProps } from "../models/GenericCardProps"; 
import { useEffect, useState } from "react";
import ConfirmationDialog from "./shared/ConfirmDialog";
import {
    StyledCard,
    StyledCardHeader,
    StyledCardContent,
    StyledListItem,
    StyledDeleteButton,
    StyledCardActions,
    StyledButton,
    StyledListItemText
} from "./AttachmentsCard.styles";

 
const AttachmentsCard = (props: GenericCardProps) => { 

    const elliHost = ElliHost.getInstance();
    const dispatch = useDispatch();
    const attachments = useTypedSelector((state) => state.appSlice.attachments);

    const [enableClearButton, setEnableClearButton] = useState<boolean>(false);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    //setting clear button enabled
    useEffect(() => {
        setEnableClearButton(attachments.length > 0);
    }, [attachments])

    const openResourceUpload = async () => {
        dispatch(setLoadingState( { loading: true, loadingMessage: "Loading Resources" }));
        const files = await elliHost.getResources();
        dispatch(setLoadingState({ loading: false, loadingMessage: "" }));
        dispatch(addAttachments(files));
    }

    const handleAttachmentDelete = (id: string) => {
        dispatch(removeAttachment(id));
    }

    const handleClearAttachments = () => {
        dispatch(clearAttachments());
        setConfirmDialogOpen(false);
    }

    return (
        <>
            <StyledCard visible={props.visible ?? false}>
                <StyledCardHeader 
                    title={((props.title && props.title !== "") ? props.title : "Attachments")}
                />
                <StyledCardContent>
                    <List dense={true}>
                        {attachments?.map((attachment) =>
                            <StyledListItem 
                                key={attachment?.id} 
                                secondaryAction={
                                    <StyledDeleteButton 
                                        edge="end" 
                                        aria-label="delete"
                                        disabled={!props.enabled}
                                        onClick={() => handleAttachmentDelete(attachment?.id)}
                                    >
                                        <DeleteIcon />
                                    </StyledDeleteButton>
                                }>
                                <StyledListItemText
                                    primary={attachment?.name}
                                    secondary={attachment?.source}
                                />
                            </StyledListItem>
                        )}
                    </List>
                </StyledCardContent>
                <StyledCardActions>
                    <StyledButton 
                        variant="contained" 
                        size="small" 
                        onClick={openResourceUpload} 
                        disabled={!props.enabled}>
                        Browse and Attach
                    </StyledButton>
                    <StyledButton 
                        variant="contained" 
                        size="small" 
                        color="error" 
                        onClick={() => setConfirmDialogOpen(true)} 
                        disabled={!enableClearButton}>
                        Clear
                    </StyledButton>
                </StyledCardActions>
            </StyledCard>
            <ConfirmationDialog
                open={confirmDialogOpen}
                title={"Confirm Action"}
                message={"Are you sure you want to clear the 'Attachments' list?"}
                onConfirm={handleClearAttachments}
                onCancel={() => setConfirmDialogOpen(false)} />
        </>
    )
}

export default AttachmentsCard;